export default __webpack_public_path__ + "static/media/logoPadelAdmin.4089f9f8.svg";